import React from 'react';
import { MemberDataCaptureStepper } from 'Organisms/MemberDataCapture/MemberDataCaptureStepper';
import fr from 'facet-rest';
import { useSnackbarContext } from 'Context/SnackbarContext';
import PropTypes from 'prop-types';
import { MemberDataCaptureCurrentContainer } from 'Organisms/MemberDataCapture/MemberDataCaptureCurrentContainer';

const MemberDataCaptureLayout = ({ resource, setPage }) => {
  const { displayErrorMessage } = useSnackbarContext();
  const isReadOnly = !resource?.meta().canSubmit();

  async function markCurrentAsComplete() {
    try {
      setPage(await resource.submit());
    } catch (e) {
      displayErrorMessage(e, e.errors[0]?.detail || 'Unable to proceed. Please try again later.');
    }
  }

  return (
    <>
      {resource && <MemberDataCaptureStepper resource={resource} setPage={setPage} />}
      {resource.withRelationship(
        fr.relationships.current.name,
        (rel) => (
          <MemberDataCaptureCurrentContainer
            relationship={rel}
            onSubmit={markCurrentAsComplete}
            readonly={isReadOnly}
          />
        ),
        () => null,
      )}
    </>
  );
};

MemberDataCaptureLayout.defaultProps = {};

MemberDataCaptureLayout.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
  setPage: PropTypes.func.isRequired,
};

export { MemberDataCaptureLayout };
